import {styled} from '@mui/material/styles';
import {ToggleButton} from '@mui/material';
import LEGACY_COLORS from '@/styles/legacyColors';

const VerticalTagsToggleButton = styled(ToggleButton)`
  &.MuiButtonBase-root {
    &.MuiToggleButton-root {
      &.MuiToggleButton-sizeMedium {
        &.MuiToggleButton-standard {
          color: ${LEGACY_COLORS.GRAY};
          border: 1px solid ${LEGACY_COLORS.GRAY_LIGHT};
          border-radius: 32px;
          font-size: 15px;
          font-weight: 300;
          padding: 4px 18px;
          text-transform: none;
          line-height: 23px;
          margin-top: 14px;
          margin-right: 15px;
          &.Mui-selected {
            background-color: ${LEGACY_COLORS.GRAY};
            color: #fff;
          }
        }
      }
    }
  }
`;

export default VerticalTagsToggleButton;
